"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentDataDomain = exports.DefaultAppDomain = void 0;
exports.DefaultAppDomain = 'org.standardnotes.sn';
/* This domain will be used to save context item client data */
exports.ComponentDataDomain = 'org.standardnotes.sn.components';
